import getCDNURL from './getCDNURL';

export const DUPR_LOGO = getCDNURL('https://images.pickleball.com/global/outside/DUPR.png', 120, 36);
export const DUPR_WIDTH = 60;
export const DUPR_HEIGHT = 18;
